import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Radio } from 'next-common-lib';
import i18n from 'i18n';

const RadioForm = ({ items, name, isDisable }) => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  return items.map(item => (
    <Radio
      key={name + item.value}
      id={name + item.value}
      name={name}
      componentType="normal"
      value={item.value}
      label={i18n.t(item.title)}
      size="md"
      checked={item.value?.toString() === value?.toString()}
      onChange={onChange}
      disabled={isDisable}
    />
  ));
};

RadioForm.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  isDisable: PropTypes.bool,
};

RadioForm.defaultProps = {
  isDisable: false,
};

export default RadioForm;
